'use client';

import useVelocityStore from '../../stores/VelocityStore/useVelocityStore';
import useDevStore from '../../stores/useDevStore';

const DevTopWrapper = () => {
	const showRefStatus = useDevStore((s) => s.showRefCode);
	const currentReferralCode = useVelocityStore((s) => s.referrerParam);
	const referralAuthority = useVelocityStore((s) => s.referredByAuthority);

	return (
		<>
			{showRefStatus && (
				<div className="flex w-full gap-x-1 typo-body-xs text-text-default">
					<span>Ref Code : {currentReferralCode}</span>
					<span>Ref Authority : {referralAuthority?.toString()}</span>
				</div>
			)}
		</>
	);
};

export default DevTopWrapper;
